<template lang="html">

  <div class="wrapper -orientacion">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Orientación</h1>
      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
          <router-link :to="$t('enlaces.orientacion')">Orientación</router-link>
        </nav>
      </div>
    </div>





    <section class="accesos -small row-center container ais">

      <article class="column-center -empresas">
        <div>
          <h2>Empresas</h2>
          <p>Descubre las empresas que te ayudarán en tu desarrollo como profesional.</p>

        </div>
        <router-link :to="$t('enlaces.buscadorrecursos') + '/empresas'" class="btn -skull -white">Saber
              más</router-link>
            <router-link :to="$t('enlaces.buscadorrecursos') + '/empresas'" class="enlace-cover"></router-link>
      </article>
      <article class="column-center salidas-profesionales">
        <div>
          <h2>Salidas Profesionales</h2>
            <p>Conoce lo que el mercado te puede ofrecer.</p>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursos') + '/salidas-profesionales'" class="btn -skull -white">Saber
              más</router-link>
            <router-link :to="$t('enlaces.buscadorrecursos') + '/salidas-profesionales'"
              class="enlace-cover"></router-link>
      </article>
      <article class="column-center recursos">
        <div>
         
          <h2>Recursos</h2>
            <p>Encuentra las herramientas que te prepararan para tu futuro profesional.</p>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursos') + '/recursos'" class="btn -skull -white">Saber
              más</router-link>
            <router-link :to="$t('enlaces.buscadorrecursos') + '/recursos'" class="enlace-cover"></router-link>
      </article>

      <article class="column-center otros-orientacion">
        <div>
          <h2>Otros</h2>
        </div>
        <a @click="clickForm('otros')" class="btn -skull -white">Saber más</a>
            <a @click="clickForm('otros')" class="enlace-cover"></a>
      </article>


    </section>

      

    <div class="contenedor-boton">
      <router-link :to="$t('enlaces.buscadorrecursos')" class="btn -skull -white">Acceder al buscador</router-link>
    </div>

    <destacados :position="'3'"></destacados>




    <section class="proyecto-formativo -protagoniza">
      <div class="container column-center">
        <h2 class="big-bold-title">Protagoniza tu futuro</h2>
        <p>Ponemos a tu disposición un Programa de Acompañamiento para el inicio de tu Carrera Profesional. Participa en
          talleres y mentorías individuales donde descubrirás cómo enfocar tus fortalezas para conseguir ser el
          profesional que estás llamado a ser.</p>

        <a href="/static/pdfs/programa-protagoniza-tu-futuro.pdf" class="btn -skull -white">Programa</a>
      </div>
    </section>


    <section class="enlaces-interes">

      <div class="container row-between">

        <h2 class="light-title">Enlaces de interés</h2>

        <div class="interes column-start">
          <h2>Centro de emprendimiento UFV</h2>
          <p>Crea el futuro. Transforma la sociedad</p>
          <div class="contenedor-botones row-start">
            <a target="_blank" href="http://www.emprendimientoufv.es/ " class="btn -skull">Ver</a>

          </div>
        </div>

        <div class="interes column-start">
          <h2>Alumni UFV</h2>
          <p>Sigue vinculado con tu Universidad</p>
          <div class="contenedor-botones row-start">
            <a target="_blank" href="https://www.alumni-ufv.es/  " class="btn -skull">Ver</a>

          </div>
        </div>

        <div class="interes column-start">
          <h2>GOE UFV</h2>
          <p>Gabinete de Orientación Educativa</p>
          <div class="contenedor-botones row-start">
            <a target="_blank" href="https://www.ufv.es/extension-universitaria/gabinete-de-orientacion-educativa/ "
              class="btn -skull">Ver</a>

          </div>
        </div>

        <div class="interes column-start">
          <h2>Becas y ayudas económicas UFV</h2>
          <p>Accede a todas las ayudas económicas que te ofrece la Universidad</p>
          <div class="contenedor-botones row-start">
            <a target="_blank" href="https://www.ufv.es/servicio-de-ayudas-al-estudio/ " class="btn -skull">Ver</a>

          </div>
        </div>

      </div>

    </section>


    <section class="conectados-home">


      <div class="container row-between ais">


        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">


        <div class="main-card">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="showsecondarycard" @click="showsecondarycard = false">
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o
            necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para
            quien ahora comienza.</p>
          <p>¿Quieres apoyar a los jóvenes talentos?</p>
          <div class="boton-redondo"></div>

          <router-link :to="$t('enlaces.conectados') + '/profesional'" class="btn -skull -white">Conecta</router-link>
        </div>

        <div class="secondary-card" :show="showsecondarycard" @click="showsecondarycard = !showsecondarycard">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="!showsecondarycard">
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te
            enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las
            decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <router-link :to="$t('enlaces.conectados') + '/alumno'" class="btn -skull -white">Conecta</router-link>
        </div>
      </div>

    </section>

    <al-dia-banner :position="3"></al-dia-banner>

  </div>

</template>


<script lang="js">

import bannerconectados from '@/components/parts/banner-conectados';
import aldiabanner from '@/components/parts/al-dia-banner';

import aldia from '@/components/view-parts/home/al-dia';

import destacados from '@/components/parts/destacados';

import filtro from '@/components/parts/filtro'

import Slick from 'vue-slick';

import { mapGetters } from 'vuex';

export default {
  name: 'orientacion',
  data() {
    return {
      showproyectoformativo: false,
      showFiltro: false,
      filter: '',
      page: 1,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: false
      },
    }
  },
  computed: {
    ...mapGetters({
      recursos: 'getRecursosOrientacion'
    }),
    elements() {

      let elements = new Array();

      if (!!this.filter) {

        elements = this.recursos;
        //AREAS
        if (!!this.filter.area) {
          elements = elements.filter(e => (e.area.some(a => a.slug == this.filter.area)));
        }

        if (!!this.filter.categoria) {
          elements = elements.filter(e => (e.categoria.some(a => a.slug == this.filter.categoria)));
        }

        if (!!this.filter.titulos) {
          elements = elements.filter(e => (e.titulos.some(a => a.slug == this.filter.titulos.slug)));
        }

        if (!!this.filter.tags) {
          elements = elements.filter(e => {
            let existe = false;

            if (!!e.tags) {
              e.tags.forEach(t => {
                (this.filter.tags.some(tag => tag == t)) ? existe = true : null;
              })
            }

            return existe;

          });
        }

        if (!!this.filter.search) {

          let searchIn = ['titulo', 'entradilla'];

          elements = elements.filter(element => {

            let can = false;

            searchIn.forEach(where => {
              (element[where].toLowerCase().includes(this.filter.search.toLowerCase())) ? can = true : '';
            });

            return (can) ? element : '';
          });

        }

        if (!!this.filter.fecha) {
          let actual = new Date().getTime();
          const SEMANAVAL = 604800000;
          let limit;
          switch (this.filter.fecha) {
            case 'day':
              limit = (actual - SEMANAVAL);
              break;
            case 'month':
              limit = (actual - SEMANAVAL * 4);
              break;
            case 'ever':
              limit = 0;
              break;
          }

          elements = elements.filter(o => {
            let fecha = new Date(o.fecha.full).getTime();
            return (fecha >= limit);
          });


        }

      } else {
        elements = this.recursos;
      }

      return elements;
    },
    perpage() {
      return 3;
    },
    pages() {
      return Math.ceil(this.elements.length / this.perpage);
    }
  },
  methods: {
    prev() {
      if (this.page > 1) {
        this.page--;
      }
    },
    next() {
      if (this.page < this.pages) {
        this.page++;
      }
    },
    setPage(page) {
      this.page = page;
    },
    clickForm(value) {
      $('html,body').animate({ scrollTop: $(".filtro").offset().top - 100 }, 500, 'swing');
      this.$refs.filtro.setArea(value);
    }
  },
  components: {
    'banner-conectados': bannerconectados,
    'al-dia-banner': aldiabanner,
    'al-dia': aldia,
    'destacados': destacados,
    'filtro': filtro,
    Slick
  },
  filters: {
    stringcategoria(value) {
      if (value.length > 1) {

        let cats = new Array();
        value.forEach(v => {
          cats.push(v.nombre);
        })
        let last = cats.pop();
        return cats.join(", ") + ' y ' + last;
      } else {
        return value[0].nombre
      }
    }
  }
}
</script>

<style scoped lang="scss">
.accesos-home {
  article {
    padding: 65px 20px;
    justify-content: flex-start;

    h2 {
      min-height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:nth-child(1) {
      background: url(/static/img/accesos-orientacion-1.jpg) center/cover no-repeat;
    }

    &:nth-child(2) {
      background: url(/static/img/accesos-orientacion-2.jpg) center/cover no-repeat;
    }

    &:nth-child(3) {
      background: url(/static/img/accesos-orientacion-3.jpg) center/cover no-repeat;
    }
  }
}


.al-dia-home {
  background: white;
}

.contenedor-boton {
  margin-bottom: 40px;
  margin-top: 20px;
}

@media screen and (max-width: 1400px) {
  .accesos article {
    padding: 50px 20px;
  }
}

@media screen and (max-width: 900px) {
  .accesos article {
    padding: 100px 20px;
    width: 50%;
    min-height: 80.32vw;
  }
}

@media screen and (max-width: 500px) {
  .accesos article {
    padding: 100px 20px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/orientacion.vue